import { Button } from "@/components/ui/button";
import { ChevronLeftRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface BottomBarProps {
  backLink: string;
  children?: React.ReactNode;
}

function BottomBar({ backLink, children }: BottomBarProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div
      className="flex h-16 shrink-0 items-center justify-between border bg-white px-6 shadow"
    >
      <Button variant="outline" onClick={() => navigate(backLink)}>
        <ChevronLeftRegular className="mr-2" />
        <span>{t("back")}</span>
      </Button>
      <div>{children}</div>
    </div>
  );
}

export default BottomBar;
